import React from 'react'
import HeaderSection from '../../../../components/common/Header/HeaderSection'
import AddForm from './Viewall'

const Liability = () => {
    return (
        <div>
            <HeaderSection
                title="Withdrawal Voucher"
                breadcrumb={["Dashboard", "Voucher", "Withdrawal List"]}
            />
            <AddForm />
        </div>
    )
}

export default Liability